<template>
  <!-- ctw-to-pros atpco price error on navigate fixed -->
  <div v-if="apiProsConfigsResponse || handledError" class="prosContainer">
    <div class="prosContainer__lib">
      <ctw-info-search
        :search="searchInformation"
        :airports-info="apiProsConfigsResponse?.availability.airports_information"
      />
      <ctw-lib
        :availability="apiProsConfigsResponse?.availability"
        :searchInformation="searchInformation"
        :showTermsAndConditions="showTermsAndConditions"
        @onFlightsSelected="(journey) => setSelectedJourney(journey)"
        doubleFlightSelection
        @onFinishSelection="onFinishSelection"
        @isReturnView="(isReturnView) => updateReturnView(isReturnView)"
        @onFlightdAdded="continueButton"
        ref="pros-lib"
        :handledError="handledError"
        :order-flight-options="getOptions"
        @onDateChanged="onDateChanged"
        @onSegmentDeleted="onSegmentDeleted"
        :configurations="{
          displayFullPrices: true,
          carousel: {
            ...carouselConfigurations,
            calendarDates
          },
          upsellingConditionsAlphabetically: ecommerceSetup?.atpco_conditions_order === 2,
          showFlightRemarks: ecommerceSetup?.show_flight_remarks
        }"
      >
      </ctw-lib>
    </div>

    <briefSummary
      :flightSelected="parsedInformation?.flightSelected"
      :flightReturnSelected="parsedInformation?.flightReturnSelected"
      :summaryBehavior="{
        showSummary: $store.state.systemStore.summaryBehavior.showSummary
      }"
      :finalList="parsedInformation?.finalLists?.finalList"
      :finalReturnList="parsedInformation?.finalLists?.finalReturnList"
    />
  </div>
</template>

<script>
import ctwLib from 'ctw-lib/src/components/Pros'
import briefSummary from 'core-lib/components/briefSummary/briefSummary.vue'
import axios from 'axios'
// import promiseBuilder from '../promises/promiseBuilder'
import CtwInfoSearch from '@/components/CtwInfoSearch'
import moment from 'moment'
import handleError from 'ctw-lib/src/helpers/errorHandler'
import { isEmpty } from 'lodash'

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const errorData = error.response.data
    if (errorData) {
      errorData.handledError = handleError(errorData.extended?.exception)
    }
    return Promise.reject(error)
  }
)

export default {
  name: 'containerCtw',
  components: {
    ctwLib,
    briefSummary,
    CtwInfoSearch
  },
  inject: ['isMobile'],
  data () {
    return {
      apiProsConfigsResponse: undefined,
      searchInformation: undefined,
      totalPassengers: 0,
      journeySelected: null,
      parsedInformation: null,
      handledError: null,
      calendarDates: null
    }
  },
  methods: {
    fetchConfigAndDatesData: async function (apiEndpoint, payload) {
      this.$store.commit('setLoading', true)
      try {
        const [calendarDates, apiProsConfigsResponse] = await Promise.all([
          this.getDates(),
          this.getConfig(apiEndpoint, payload)
        ])
        this.calendarDates = calendarDates
        this.apiProsConfigsResponse = apiProsConfigsResponse
        this.$emit('buttonMessageConfig', this.apiProsConfigsResponse.configs.bottom_message)
        this.$emit('areTermsAndConditionsActivated', this.showTermsAndConditions)
        this.$emit('flightInfo', this.apiProsConfigsResponse.availability)
      } catch (error) {
        const { handledError } = error.response.data
        this.handledError = handledError
      } finally {
        this.$store.commit('setLoading', false)
      }
    },
    getConfig: async function (apiEndpoint, payload) {
      try {
        // const url = `${this.$store.getters.getConfigUrls.apiBaseUrl}flightresults/api/v2/${apiEndpoint}/`
        // const apiOrFake = process.env.VUE_APP_FAKE_CONFIG_V2
        // const apiCall = payload ? axios.post(url, payload) : axios.get(url)
        // const response = apiOrFake ? await promiseBuilder(apiOrFake) : await apiCall
        let response = null
        if (payload) {
          response = await this.$api.flightsResult.setConfig(apiEndpoint, payload)
        } else {
          response = await this.$api.flightsResult.getConfig(apiEndpoint)
        }

        return response.data.response
      } catch (error) {
        console.error('Error al obtener configuración:', error)
        throw error
      }
    },
    onFinishSelection: function () {
      let selectedJourney
      for (const journey of Object.values(this.journeySelected)) {
        selectedJourney = {
          journey_code: journey.fare.fare_key,
          family_fare: journey.fare.code
        }
        this.parsedInformation.selected_journeys = this.parsedInformation.selected_journeys ?? []
        if (!this.parsedInformation.selected_journeys.some(journey => journey.journey_code === selectedJourney.journey_code)) {
          this.parsedInformation.selected_journeys.push(selectedJourney)
        }
      }
      this.flightAction(this.parsedInformation)
    },
    flightAction: async function (shoppingSelected) {
      // const baseUrl = this.$store.getters.getConfigUrls.apiBaseUrl
      // const url = `${baseUrl}flightresults/api/${this.$store.getters.getApiVersion}/action/`

      try {
        // const response = await axios.post(url, shoppingSelected)
        const response = await this.$api.flightsResult.flightAction(this.$store.getters.getApiVersion, shoppingSelected)
        console.log('result:', response.data)
        this.$store.dispatch('goNextSpa')
      } catch (error) {
        console.error('error:', error)
      }
    },
    continueButton: function () {
      this.$refs['pros-lib'].executeContinueCallback()
    },
    back: function () {
      const prosRef = this.$refs['pros-lib']
      if (prosRef.prepareToBackPage) {
        this.$store.commit('setLoading', true)
        window.location.href = this.$store.getters.getGeneralSettings.ecommerce_setup.logo_redirect_url
      }
      prosRef.executeBackCallback()
    },
    updateReturnView: function (isReturnView) {
      this.$parent.isReturn = isReturnView
      this.$parent.isReturnViewActivated = isReturnView
    },
    onSegmentDeleted (tripSegment) {
      this.$store.commit('onSegmentDeleted', tripSegment)
    },
    setSelectedJourney: function (journey) {
      if (isEmpty(journey)) {
        this.parsedInformation = null
        this.$emit('selectFlight', journey)
        return this.$store.commit('summaryBehaviorHandler', {
          state: 'absolute',
          showSummary: false
        })
      }

      this.journeySelected = journey
      let flightReturnSelected = this.parseFlightSelected(
        this.journeySelected[2]
      )
      this.parsedInformation = {
        finalLists: {
          finalList: this.convertToCamelCase(
            this.parseFlightDetail(this.journeySelected[1]?.flight_detail)
          ),
          finalReturnList: this.convertToCamelCase(
            this.parseFlightDetail(this.journeySelected[2]?.flight_detail)
          ) || []
        },
        flightSelected: this.parseFlightSelected(this.journeySelected[1]),
        flightReturnSelected
      }

      if (this.journeySelected[1] && this.$breakpoint.isDesktop) {
        this.$store.commit('summaryBehaviorHandler', {
          state: 'absolute',
          showSummary: true
        })
      }
      this.$emit('selectFlight', journey)
    },
    parseFlightDetail: function (detail) {
      if (!detail) return []
      const parseDepartureOrArrival = function (departureOrArrival) {
        const oldKeys = { ...departureOrArrival }
        return {
          airport: departureOrArrival.location_name,
          airport_short: departureOrArrival.airport_reference_id,
          city: departureOrArrival.location_city_name,
          datetime: departureOrArrival.date,
          time: departureOrArrival.time,
          ...oldKeys
        }
      }
      return detail.map(flightDetail => ({
        ...flightDetail,
        journey_duration: this.formatMinutesToHours(flightDetail.journey_duration),
        arrival: parseDepartureOrArrival(flightDetail.arrival),
        departure: parseDepartureOrArrival(flightDetail.departure),
        airline: flightDetail.carrier_code,
        operating_carrier: flightDetail.operating_carrier
      }))
    },
    convertToCamelCase (obj) {
      if (Array.isArray(obj)) {
        return obj.map((item) => this.convertToCamelCase(item))
      } else if (typeof obj === 'object' && obj !== null) {
        const newObj = {}
        Object.keys(obj).forEach((key) => {
          const camelKey = key.replace(/_([a-z])/g, (match, p1) =>
            p1.toUpperCase()
          )
          newObj[camelKey] = this.convertToCamelCase(obj[key])
        })
        return newObj
      } else {
        return obj
      }
    },
    parseFlightSelected: function (journey) {
      if (!journey) return undefined
      return {
        price: `${journey.fare.id}`,
        flight: {},
        fare: {
          name: journey.fare.name,
          price: journey.fare.fare_information,
          journeyName: journey.fare.fare_key
        },
        generalInfo: {
          stops: journey.stops,
          flyTime: this.formatMinutesToHours(journey.travel_time)
        }
      }
    },
    formatMinutesToHours: function (minutes) {
      if (!minutes) return null
      const duration = moment.duration(minutes, 'minutes')
      const formattedTime = moment.utc(duration.asMilliseconds()).format('HH:mm')
      return formattedTime
    },
    getIdShooping (date) {
      const idShoppingMask = (this.$store.getters.getConfigUrls?.idShoppingMask ? this.$store.getters.getConfigUrls.idShoppingMask : 45678)
      let idShooping = moment(date).valueOf()
      idShooping = idShooping * idShoppingMask
      /*
      // volver para atras
      let NewId = idShooping
      NewId = NewId / idShoppingMask
      console.log(moment(NewId).format('YYYY-MM-DD'))
      */
      return idShooping
    },
    onDateChanged: async function (payload) {
      // add new prop to validate in back
      payload.idShopping = this.getIdShooping(payload.departure_date)
      await this.fetchConfigAndDatesData('reload', payload)
    },
    getDates: async function () {
      // const url = `${this.$store.getters.getConfigUrls.apiBaseUrl}searchflight/api/v1`
      // axios.defaults.headers.common['Carrier'] = this.$store.getters.getCarrier
      try {
        /*
        const response = await axios.get(`${url}/dates/`, {
          params: {
            origin: this.searchInformation.origin,
            destination: this.searchInformation.destination,
            is_round_trip: this.searchInformation.return_flight ? 1 : 0
          }
        })
        */

        const params = {
          origin: this.searchInformation.origin,
          destination: this.searchInformation.destination,
          is_round_trip: this.searchInformation.return_flight ? 1 : 0
        }

        const response = await this.$api.searchFlights.getFlightsDates(params)
        return response.data.response
      } catch (err) {
        console.error('Error al obtener fechas:', err)
        throw err
      }
    }
  },
  computed: {
    ecommerceSetup: function () {
      return this.$store.getters.getGeneralSettings?.ecommerce_setup
    },
    getOptions: function () {
      const options = this.ecommerceSetup?.sort_field_options.options
      const filteredOptions = !options ? null : Object.keys(options)
        .filter(key => options[key])
        .sort((optionAKey, optionBKey) => options[optionAKey] - options[optionBKey])
        .map(name => ({ label: name, value: name }))
      return filteredOptions
    },
    carouselConfigurations: function () {
      if (!this.apiProsConfigsResponse?.configs) return
      const { carousel: display, lower_fare: displayFares, show_arrival_flight: displayOnArrival, show_departure_flight: displayOnDeparture } = this.apiProsConfigsResponse.configs?.carousel
      return {
        display,
        displayFares,
        displayOnArrival,
        displayOnDeparture
      }
    },
    showTermsAndConditions: function () {
      return this.apiProsConfigsResponse?.configs?.term_condition?.term_condition
    }
  },
  beforeMount: async function () {
    this.$store.commit('summaryBehaviorHandler', {
      state: 'absolute',
      showSummary: false
    })
    this.searchInformation = this.$store.getters.getSearchData
    const { adults, minors, infants } = this.searchInformation
    this.$store.commit('setSearch', this.searchInformation)
    this.totalPassengers = adults + minors + infants
    await this.fetchConfigAndDatesData('configs')
  }
}
</script>

<style lang="sass">
.prosContainer__lib
  display: flex
  flex-direction: column
  gap: 3rem
.prosContainer__filter
  display: flex
  align-items: center
  justify-content: flex-end
  min-width: 50%
  gap: 1rem
.prosContainer__filterTitle
  color: var(--color-primary)
  font-size: var(--font-size-base)
.prosContainer__filterSelect
  padding: 0 !important
  select
    background-color: #fff
    border-radius: 0
    border: 1px solid var(--color-overlay-20)
@media (max-width: 768px)
  .prosContainer__lib
    z-index: 1000
    background: var(--color-background)
    transition: width .2s ease
    padding: 0
    width: 100%
</style>
